export const normName = (s) => (s || "").trim().toLowerCase();
export const isLeaf = (n) => n.tipoFigli == null;

export const childrenOf = (all, pid) => all.filter((d) => d.idPadre === pid);

export const usedDomainValsByChildren = (all, parent) =>
  childrenOf(all, parent.tempId).map((c) => c.dominioVal).filter(Boolean);

export const maxAssegnabili = (all, parent) =>
  Math.max(0, (parent.dominio?.length || 0) - usedDomainValsByChildren(all, parent).length);

export const getDescrizioneFromParent = (parent, dominioVal) => {
  const i = (parent.dominio || []).findIndex((v) => v === dominioVal);
  return i >= 0 ? (parent.descrizioni || [])[i] : null;
};

export const siblingNameSet = (all, parent) =>
  new Set(childrenOf(all, parent.tempId).map((c) => normName(c.nome)));

export const dominiValidi = (rows = []) => {
  const norm = rows.map((d) => ({
    valore: (d.valore || "").trim(),
    descrizione: (d.descrizione || "").trim(),
  }));
  const nessunaParziale = norm.every(
    (r) => (r.valore === "" && r.descrizione === "") || (r.valore && r.descrizione)
  );
  const almenoUna = norm.some((r) => r.valore && r.descrizione);
  return { ok: nessunaParziale && almenoUna, rows: norm.filter((r) => r.valore && r.descrizione) };
};

export const buildBulkPayload = (drafts, baseline) => ({
  baselineLeafName: baseline,
  nodes: drafts.map((n) => ({
    tempId: n.tempId,
    parentTempId: n.idPadre,
    type: n.isRadice ? "NONFOGLIA" : (!n.tipoFigli ? "FOGLIA" : "NONFOGLIA"),
    nome: n.nome,
    campo: n.campo ?? null,
    isRadice: !!n.isRadice,
    tipoFigli: n.tipoFigli ?? null,
    dominioVal: n.dominioVal ?? null,
    descrizione: n.descrizione ?? null,
    dominio: n.dominio ?? [],
    descrizioni: n.descrizioni ?? [],
    conversionFactor: n.conversionFactor ?? null,
  })),

  
});

/** Costruisce livelli a partire dalla radice (BFS) */
export const buildLevels = (all, root) => {
  const levels = [];
  if (!root) return levels;
  levels.push([root]);
  let cur = [root];
  const visited = new Set([root.tempId]);
  while (cur.length) {
    const next = [];
    for (const n of cur) {
      for (const ch of all.filter((d) => d.idPadre === n.tempId)) {
        if (!visited.has(ch.tempId)) { next.push(ch); visited.add(ch.tempId); }
      }
    }
    if (next.length) levels.push(next);
    cur = next;
  }
  return levels;
};

/** Archi padre→figlio per il disegno delle frecce */
export const buildEdges = (all) =>
  all.filter((n) => n.idPadre).map((n) => ({ from: n.idPadre, to: n.tempId }));

// PER LA VISUALIZZAZIONE INVECE 

export const groupRoots = (all) => all.filter((n) => n.isRadice || n.idPadre == null);

export const collectSubtree = (all, root) => {
  const byParent = new Map();
  all.forEach(n => {
    const key = n.idPadre ?? null;
    if (!byParent.has(key)) byParent.set(key, []);
    byParent.get(key).push(n);
  });

  const out = [];
  const stack = [root];
  const seen = new Set();

  while (stack.length) {

    const cur = stack.pop();
    if (seen.has(cur.tempId)) continue;
    seen.add(cur.tempId);
    out.push(cur);

    const children = byParent.get(cur.tempId) || [];
    children.forEach(ch => stack.push(ch));
  }
  return out;
};


